import { Typography } from "@mui/material";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import React from "react";
import styles from "./LabeledTextarea.module.css";

function LabeledTextarea({placeholder,errors, label, required, register, name }) {
  return (
    <label className={styles.textfield} htmlFor="">
      <div className={styles.heading}>
        <Typography>{label}   {required && <span style={{ color: "red" }}>*</span>}</Typography>
      
      </div>
      <textarea placeholder={placeholder}  {...register(name)} name={name} cols="30" rows="10"></textarea>
      {errors[name] && <ValidationMessage message={errors[name]?.message} />}
    </label>
  );
}

export default LabeledTextarea;
